import { map } from '../map'
import { setInfoBox, createInfoBox } from './infoBox'
import singleMarker from './infoBox/templates/singleMarker'
import markerLabel from './infoBox/templates/markerLabel'
import { getColor } from '../utils/constants'
import { planeSymbolDefault } from '../polylines/symbols'
import { setPolyline } from '../polylines'
import createPolyline from '../polylines/createPolyline'

const createRoute = (toMarker, fromMarkers, bounds) => {
  const opts = {
    content: singleMarker(toMarker),
    position: toMarker.position,
    disableAutoPan: true // has to be true, start idle event otherwise and map rerender multiple times
  }

  const to = createInfoBox(opts)

  to.id = toMarker.id
  to.pixelOffset_.height = -67
  to.pixelOffset_.width = -25
  setInfoBox(to)
  to.open(map)
  bounds.extend(to.position_)

  for (let i = 0; i < fromMarkers.length; i++) {
    // CREATE FROM INFOBOX
    const opts = {
      content: markerLabel(fromMarkers[i]),
      position: new google.maps.LatLng(fromMarkers[i].x, fromMarkers[i].y),
      disableAutoPan: true // has to be true, start idle event otherwise and map rerender multiple times
    }

    const from = createInfoBox(opts)

    from.id = fromMarkers[i].id
    from.pixelOffset_.height = -35
    from.pixelOffset_.width = -20
    setInfoBox(from)
    from.open(map)
    bounds.extend(from.position_)

    // CREATE POLYLINE WITH PLANE
    const routePolyline = [
      {lat: toMarker.position.lat(), lng: toMarker.position.lng()},
      new google.maps.LatLng(fromMarkers[i].x, fromMarkers[i].y)
    ]

    const polylineOpts = new google.maps.Polyline({
      fromId: fromMarkers[i].id, // starting infoBox ID
      toId: toMarker.id, // endgind infoBox ID
      planePosition: null, // holds current postion of moving plane on polyline
      path: routePolyline, // strating and ending points in lat + lng
      geodesic: false, // polyline is not curved, it is straight
      strokeColor: getColor('POLYLINE'),
      strokeOpacity: 1.0,
      strokeWeight: 2,
      icons: [{
        icon: planeSymbolDefault(),
        offset: '100%'
      }],
    })

    const polyline = createPolyline(polylineOpts)
    setPolyline(polyline)
  }
}

export default createRoute



// WEBPACK FOOTER //
// ./app/utils/createRoute.js